module.exports = __webpack_public_path__ + "static/media/Education - Cerebrovascular.1360508e.svg";